import urls from "../constants";
import { useFetch } from "./useFetch";

export function useServices() {
    const { sendGet } = useFetch();
    const getServices = async (token) => {
        try {
            const services = [];
            const servicesUrlOnline = urls.SERVICES_URL;
            const servicesUrlSouthampton = `${urls.SERVICES_URL}&southampton=true`;
            const onlinePromise = sendGet(servicesUrlOnline, {
                    AccessToken: token
                }
            );
            const southamptonPromise = sendGet(servicesUrlSouthampton, {
                    AccessToken: token
                }
            );
            const [onlineResponse, southamptonResponse] = await Promise.all([onlinePromise, southamptonPromise]);
            onlineResponse.forEach(service => {
                services.push({ ...service, Location: 'Online' })
            });
            southamptonResponse.forEach(service => {
                services.push({ ...service, Location: 'Southampton' })
            });
            services.sort((a, b) => new Date(a.StartTime) - new Date(b.StartTime));
            return services;
        } 
        catch (error) {
            console.error(error);
            return [];
        }
    }
    return { getServices };
}